import {
  AfterViewInit,
  Component,
  DoCheck,
  Input,
  OnInit
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { TranslateService } from '@ngx-translate/core';

import {
  HaynesProVesaFaultCodeComponentModel,
  HaynesProVesaFaultCodeDiagnosticDataModel
} from '../typings/haynes-pro.vesa';

@Component({
  styles: [ require('./haynes-pro.diagnostic-tool.vesa-fault-codes.expanded-row.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.vesa-fault-codes.expanded-row.component.html')
})
export class HaynesProDiagnosticToolVesaFaultCodesExpandedRowComponent implements AfterViewInit, DoCheck, OnInit {

  @BlockUI('haynesProVesaFaultCodesRowBlock') block : NgBlockUI;

  @Input() onShowDiagnosis : ( component : HaynesProVesaFaultCodeComponentModel ) => void;
  @Input() record          : any;
  @Input() rowExpansionData: any;
  @Input() vehicleId       : number;

  get components () : Array<HaynesProVesaFaultCodeComponentModel> {
    return this.data?.components || [];
  }

  get data () : HaynesProVesaFaultCodeDiagnosticDataModel {
    return this.record?.__diagnosticData;
  }

  get fallbackText () : string {
    return (this.data?.fault_code_text || this.data?.component_text || '').trim();
  }

  get hasComponents () : boolean {
    return this.components.length > 0;
  }

  get hasNoData () : boolean {
    return !this.hasComponents && !this.fallbackText;
  }

  get hasTextOnly () : boolean {
    return !this.hasComponents && !!this.fallbackText;
  }

  get isLoading () : boolean {
    return !this.record?.__activated;
  }

  get relatedFaultCodes () : string {
    const codes = (this.data?.fault_codes || [])
      .map(fc => fc?.fault_code)
      .filter(Boolean);

    return Array.from(new Set(codes)).join(', ');
  }

  constructor (public translateService : TranslateService) {}

  ngAfterViewInit () : void {
    if (this.isLoading) {
      this.block.start();
    }
  }

  ngDoCheck () : void {
    if (!this.isLoading && this.block.isActive) {
      this.block.stop();
    }
  }

  ngOnInit () : void {
    if (typeof this.rowExpansionData === 'function') {
      this.rowExpansionData(this.record);
    }
  }

  handleShowDiagnosis ( component : HaynesProVesaFaultCodeComponentModel ) : void {
    if (typeof this.onShowDiagnosis === 'function') {
      this.onShowDiagnosis(component);
    }
  }
}
